import React from "react";
import AnnualStatementForm from "./AnnualStatementForms";

const AddAnnualStatement = () => {
    return(
        <AnnualStatementForm type="Add" />
    )
}

export default AddAnnualStatement